import React from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import MyInterviewsPage from "../placement/MyInterviewsPage";

export default function EmployeeMyInterviewsPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <EmployeeNavbar />
      <MyInterviewsPage />
    </div>
  );
}
